// extracted by mini-css-extract-plugin
module.exports = {"aboutContainer":"about_aboutContainer__d_gI8"};